import {
  parameterizedString,
  currencyText,
  isDefinedAndNotEmpty,
} from '../utils';
import * as React from 'react';

import PageTitle from '../PageTitle';
import Radio from '../Radio';

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

const {
  DIRECTORY_THEME,
} = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/checkout`);

const $ST = DIRECTORY_THEME.CARGO_SELECTION;

export default class CargoSelection extends React.Component {
  constructor(props) {
    super(props);
    this.renderShippingOptions = this.renderShippingOptions.bind(this);
  }

  componentDidMount() {
    const { currentShippingOption, onSetShippingOption, shippingOptions } =
      this.props;

    if (isDefinedAndNotEmpty(shippingOptions) && !currentShippingOption) {
      onSetShippingOption(shippingOptions[0].pk);
    }
  }

  renderShippingOptions() {
    const { shippingOptions, currentShippingOption, onSetShippingOption } =
      this.props;
    return !isDefinedAndNotEmpty(shippingOptions)
      ? []
      : shippingOptions.map((opt) => {
          return (
            <div key={opt.pk} className='checkout-cargo__options-item'>
              <label
                className='checkout-cargo__options-item-label'
                onClick={(e) => {
                  e.preventDefault();
                  onSetShippingOption(opt.pk);
                }}
              >
                <div>
                  <Radio
                    name='cargo'
                    value={opt.pk}
                    onChange={() => false}
                    checked={
                      currentShippingOption
                        ? currentShippingOption.pk === opt.pk
                        : false
                    }
                  />
                </div>
                <div>{opt.name}</div>
                <div className='text-right'>
                  {opt.shipping_amount} {currencyText()}
                </div>
              </label>
              {['Lacoste Instore'].includes($A.TITLE) &&
              Boolean(opt.description) ? (
                <div className='checkout-cargo__options-item-description'>
                  {opt.description}
                </div>
              ) : null}
            </div>
          );
        });
  }

  render() {
    const { children, currentAddress } = this.props;
    return (
      <div className='checkout-cargo'>
        <div className='checkout-contents__header'>
          <PageTitle>{$ST.CARGO_COMPANY}</PageTitle>
        </div>
        <div className='checkout-contents__body'>
          {currentAddress && (
            <p>
              {parameterizedString(
                $ST.SELECT_CARGO_COMPANY,
                currentAddress.city.name
              )}
            </p>
          )}
          <div className='checkout-cargo__options'>
            {this.renderShippingOptions()}
          </div>
          {children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/checkout/CargoSelection.js